export const AuditLogs = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_383_6046)">
      <path
        d="M7.5835 2.91667V4.08333H2.91683V2.91667H7.5835ZM3.50016 6.41667H7.00016V5.25H3.50016V6.41667ZM13.4168 9.19567V12.25C13.4168 13.2148 12.6317 14 11.6668 14H0.583496V0H10.5002C11.465 0 12.2502 0.785167 12.2502 1.75V6.86233L13.4168 9.19567ZM1.75016 12.8333H8.75016V1.16667H1.75016V12.8333ZM12.2502 9.471L11.0835 7.13767V1.75C11.0835 1.42858 10.8222 1.16667 10.5002 1.16667H9.91683V12.8333H11.6668C11.9888 12.8333 12.2502 12.5714 12.2502 12.25V9.471Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_383_6046">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
